// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import LoginPage from '../pages/Login';
import RegisterPage from '../pages/Register';
import LandingPage from '../pages/LandingPage';
import PublicPostPage from '../pages/PublicPostPage';
import PostsPage from '../pages/PostsPage';
import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings';
import SuperadminPage from '../pages/SuperadminPage';
import AdminDashboard from '../pages/AdminDashboard';
import AnalyticsDashboard from '../pages/AnalyticsDashboard';
import ChurchList from '../pages/ChurchList';
import ChurchDetails from '../pages/ChurchDetails';
import EventDetails from '../pages/EventDetails';
import SendOtpPage from '../pages/SendOtpPage';
import VerifyOtpPage from '../pages/VerifyOtpPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import VerifyResetCodePage from '../pages/VerifyResetCodePage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import ProtectedLayout from '../components/ProtectedLayout';
import Messaging from '../pages/Messaging';
import FileManagerPage from '../pages/FileManager/FileManagerPage';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Open Routes (accessible by everyone, no redirect) */}
      <Route path="/post/:id" element={<PublicPostPage />} />

      {/* Public Routes */}
      <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
      <Route path="/send-otp" element={<PublicRoute><SendOtpPage /></PublicRoute>} />
      <Route path="/verify-otp" element={<PublicRoute><VerifyOtpPage /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
      <Route path="/verify-reset-code" element={<PublicRoute><VerifyResetCodePage /></PublicRoute>} />
      <Route path="/reset-password" element={<PublicRoute><ResetPasswordPage /></PublicRoute>} />

      {/* Protected Routes */}
      <Route
        element={
          <PrivateRoute>
            <ProtectedLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/posts" element={<PostsPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/analytics" element={<AnalyticsDashboard />} />
        <Route path="/superadmin" element={<SuperadminPage />} />
        <Route path="/churches" element={<ChurchList />} />
        <Route path="/churches/:id" element={<ChurchDetails />} />
        <Route path="/events/:id" element={<EventDetails />} />
        <Route path="/messaging" element={<Messaging />} />
        <Route path="/files" element={<FileManagerPage />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      {/* Fallback for any unmatched routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
